<template>
    <div>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearchParam"
                    tooltipLabel="informacao-campo-busca-parametrizacao"
                />
            </div>

            <div class="replicapda-select">
                
                <vss-select
                    title="selecione-categoria"
                    :options="categorias"
                    v-model="categoria"
                    @onBlurFunction="onCategoriaChanged"
                    tooltipLabel="informacao-campo-categoria-parametrizacao-usuario"
                    :height="40" 
                />
            </div>
        </div>

        <div class="registry-wrapper mt-5">
            <container-loader v-if="isLoadingParams && !$store.getters.isLoading" />
            <empty-table-message v-if="isEmpty" />
            <b-table
                responsive
                v-else
                :data="parametrizacoes"
                class="data-table data-table-label-word-wrap"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span class="descricao-tabela-parametrizacao">{{
                        props.row[f.key === 'label-tabela-usuario' ? 'label' : f.key]
                    }}</span>
                </b-table-column>
            </b-table>
        </div>

        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import CategoriaConfigService from '@/services/CategoriaConfigService';
import CargoService from "@/services/promotor/cliente/CargoService";
import CidadeService from '@/services/CidadeService';
import ValoresKmService from '@/services/despesas/ValoresKmService';
import gerenciarUsuarioValidation from '@/services/validations/GerenciarUsuariosValidation';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ColorPicker from '@/components/shared/form/ColorPicker';
import Message from '@/models/Message';
import GoogleMaps from '@/components/shared/maps/MapasGoogleMaps';
import { mapState } from 'vuex';
import Geral from '@/components/colaborador/gerenciar-usuario/abas/Geral';
import Parametrizacao from '@/components/colaborador/gerenciar-usuario/abas/Parametrizacao';

export default {
    components: {
        Geral,
        Parametrizacao,
        ColorPicker,
        GoogleMaps,
        ContainerLoader,
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('USUARIO'),
            optionPedidoEmail: false,
            service: new GerenciarUsuariosService(this.$http, this.$router),
            caregoriaService: new CategoriaConfigService(this.$http, this.$router),
            cargoService: new CargoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new gerenciarUsuarioValidation(this.msgs),
            date: null,
            dateInvalid: false,
            iniciocaptura: { HH: '', mm: '' },
            terminocaptura: { HH: '', mm: '' },
            loadingCargo: false,
            cargo: null,
            cargos: [],
            usuario: {
                idusuario: null,
                nome: null,
                email: null,
                login: null,
                senha: null,
                pincolor: '#D0CFCF',
                extra1: null,
                diascapturagps: '',
                iniciocaptura: null,
                terminocaptura: null,
                latitude: null,
                longitude: null,
                idcidade: null,
                idcargo: null,
                endereco: null,
                bairro: null,
                telefone: null,
                celular: null,
                datanascimento: null,
                pedidoemail: 0,
                idtipoveiculo: null,
            },
            invalidIcon: false,
            cidade: null,
            cidades: [],
            cidadeservice: new CidadeService(this.$http, this.$router),
            canSelectCidade: false,
            mapOptions: { gestureHandling: 'cooperative' },
            diasSemana: [
                { value: '1', label: 'domingo' },
                { value: '2', label: 'segunda' },
                { value: '3', label: 'terca' },
                { value: '4', label: 'quarta' },
                { value: '5', label: 'quinta' },
                { value: '6', label: 'sexta' },
                { value: '7', label: 'sabado' },
            ],
            diasSemanaSelected: [],
            invalidGetLocation: false,
            isUpdate: false,
            tipoVeiculos: [],
            tipoVeiculo: null,
            valoresKmService: new ValoresKmService(this.$http, this.$router),
            abas: ['geral', 'parametrizacoes'],
            abaSelecionada: 0,
            fields: [
                { key: 'label-tabela-usuario', width: null, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: false, sortFn: null },
                { key: 'valor', width: null, sortable: false, sortFn: null },
            ],
            isEmpty: true,
            parametrizacoes: [],
            debouncedOnSearchParam: null, //
            queryFilter: '',
            queryFilterParam: '',
            isLoadingParams: false,
            categorias: [], //
            categoria: { id: 0, label: this.$t('todos') }, //
            inputCelularEdit: false,
            inputTelefoneEdit: false,
            invalidTelefone: false,
            invalidCelular: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            validateAddress: [
                'postal_code',
                'administrative_area_level_1',
                'administrative_area_level_2',
                'route',
            ],
            cidadesFull: [],
            debounceEndereco: null,
            debounceBairro: null,
            cantEdit: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.isUpdate = this.$route.params.id ? true : false;

        let titulo = this.$route.params.id ? 'editar-usuario' : 'adicionar-usuario';
        this.permissao = this.hasPermissionAccess('admin', 'colaborador', 'usuario-gerenciar');
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: titulo },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados(this.$route.params.id);
                this.cantEdit = !this.permissao.update;
                this.debouncedOnSearchParam = this.debounce(this.onSearchParam, 500); // 
                this.carregarCategorias();
                // @84599 - Chama o método para carregar os parâmetros do usuário quando a tela é iniciada
                this.carregarParamUsuario(
                    this.pagination.currentPage,
                    this.$route.params.id,
                    this.categoria.id,
                    this.queryFilterParam
                );
            } else {
                this.findAllTipoVeiculo();
            }
            this.loadCidadeFull(10000);
            this.loadCargos()
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        optionPedidoEmail(v) {
            this.usuario.pedidoemail = v ? 1 : 0;
        },
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .findById(id)
                .then((usuario) => {
                    this.usuario = usuario.content;
                    if (this.usuario.idcidade != null) this.loadCidadeById(this.usuario.idcidade);
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false
                });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
        },
        carregarCategorias() {
            this.categorias = [];
            this.categoria = {};
            this.caregoriaService
                .findAllComboUser(this.$route.params.id, '')
                .then((value) => {
                    this.categorias.push({
                        id: 0,
                        label: this.$t('todos'),
                    });
                    if (value.status === 200) {
                        if (value.content) {
                            if (value.content.length > 0) {
                                value.content.map((e) => {
                                    this.categorias.push({
                                        id: e.idcategoriaconfig,
                                        label: e.nome,
                                    });
                                });
                                this.categoria = this.categorias[0]
                            } else {
                                this.categorias = [];
                                this.categoria = {};
                                this.categorias.push({
                                    id: 0,
                                    label: this.$t('todos'),
                                });
                                this.categoria = this.categorias[0]
                            }
                        }
                    } else {
                        this.categorias = [];
                        this.categoria = {};
                        this.categorias.push({
                            id: 0,
                            label: this.$t('todos'),
                        });
                        this.categoria = this.categorias[0]
                        console.error(value.message);
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    }
                })
                .catch((e) => {
                    this.categorias = null;
                    this.categoria = {};
                    console.error(e);
                });
        },
        carregarParamUsuario(currentPage = 1, id, situacao = 0, ...params) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoadingParams = true;
            this.service
                .getParamsUsuario(currentPage - 1, this.pagination.perPage, id, situacao, params)
                .then((value) => {
                    this.pagination.totalRows = value.totalElements;
                    this.parametrizacoes = value.content;
                    this.parametrizacoes.forEach((e) => {
                        e.valor = this.jsonFormatter(e.tipo, e.valor);
                    });
                    this.isEmpty = this.parametrizacoes <= 0;
                })
                .catch((e) => {
                    this.isLoadingParams = false;
                    this.isEmpty = true;
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoadingParams = false;
                });
        },
        loadCargos(sc) {
            this.loadingCargo = true
            this.cargoService
                .findAllCombo(50, sc)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idcargo,
                            label: m.descricao,
                        };
                    });
                })
                .then(allcargos => {
                    this.cargos = allcargos;
                    this.cargos.sort();
                    if (this.cargo) {
                        this.updateCargo(
                        this.cargos.filter(
                            sg => sg.obj.idcargo == this.cargo.idcargo
                        )[0]
                        );
                    }
                }, 350)
                .finally(() => {
                    this.loadingCargo = false
                })
        },
        onCategoriaChanged(val) {
            this.categoria = val
                ? this.categorias.filter((v) => v.id == val.id)[0]
                : this.categorias[0];
            this.carregarParamUsuario(
                this.pagination.currentPage,
                this.$route.params.id,
                this.categoria.id,
                this.queryFilterParam
            );
        },
        loadCidadeFull(limit = 100, pesquisa = '') {
            this.cidadeservice
                .findAll(0, limit, pesquisa || '')
                .then(this.mapItemsCidade)
                .then((allcidades) => {
                    this.cidadesFull = Object.assign(allcidades);
                    this.cidadesFull.sort();
                });
        },
        loadCidadeById(id) {
            
            this.cidadeservice
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                        };
                        this.cidade = temp;
                    }
                }, 350)
                .catch((e) => {
                    console.error(e);
                    
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                });
        },
        mapItemsCidade(body) {
            return body.content.map((i) => {
                return {
                    id: i.idcidade,
                    nome: i.descricao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarParamUsuario(
                value.currentPage,
                this.$route.params.id,
                this.categoria.id,
                this.queryFilterParam
            );
        },
        jsonFormatter(tipo, valor) {
            if (tipo) {
                let json = JSON.parse(tipo);
                if (json.type === 'select') {
                    return json.options.filter((e) => {
                        if (e.value === valor) {
                            return e.name;
                        }
                    })[0].name;
                } else {
                    return valor;
                }
            } else {
                return valor;
            }
        },
        /**
         * @70830 - essa função é executada a cada vez que é clicado no mapa.
         *
         * A variável validateAddress, contém todas as informações que são necessárias,
         * para um determinado endereço seja válido. Foi feito uma verificação de como o Google Maps
         * retorna o endereço.
         *
         * ['postal_code', 'administrative_area_level_1', 'administrative_area_level_2', 'route'],
         *
         * postal_colode -> Código Postal
         * administrative_area_level_1 -> Estado,
         * administrative_area_level_2 -> Cidade
         * route -> Rua, Avenida etc.
         */
        getLocationValid(lat, lng) {
            let isValid = false;

            this.$refs.gmap.codeAddress(`${lat}, ${lng}`, (result, status) => {
                if (status == 'OK') {
                    let validations = [];
                    let resultAddress = result[0].address_components;

                    resultAddress.forEach((address) => {
                        address.types.forEach((type) => {
                            if (this.validateAddress.includes(type)) {
                                validations.push(type);
                            }
                        });
                    });

                    isValid = validations.length === this.validateAddress.length;

                    if (isValid) {
                        let addressComplete = resultAddress;
                        /**
                         * @70830 - Caso o endereço contenha todas as informações, número
                         * da rua, rua, bairro, cidade, estado e código postal.
                         */
                        if (addressComplete.length == 7) {
                            let [
                                street_number,
                                route,
                                district,
                                city,
                                state,
                                _,
                                postal_code,
                            ] = addressComplete;

                            this.usuario.endereco = `${route.long_name}, ${
                                street_number.long_name
                            }, ${postal_code.long_name}`;
                            this.usuario.bairro = district.long_name;

                            let cidadeSelect = this.removeAcentos(
                                `${state.short_name} - ${city.long_name}`
                            ).toLowerCase();

                            this.cidade = this.cidadesFull.find((elemento) => {
                                return elemento.nome.toLowerCase() == cidadeSelect;
                            });
                            /**
                             * @70830 - caso o retorno não possua o número da rua.
                             */
                        } else if (addressComplete.length == 6) {
                            var [route, district, city, state, _, postal_code] = addressComplete;

                            let cidadeSelect = this.removeAcentos(
                                `${state.short_name} - ${city.long_name}`
                            ).toLowerCase();

                            this.usuario.endereco = `${route.long_name}, ${postal_code.long_name}`;
                            this.usuario.bairro = district.long_name;
                            this.cidade = this.cidadesFull.find((elemento) => {
                                return elemento.nome.toLowerCase() == cidadeSelect;
                            });
                            /**
                             * @70830 - caso o retorno não possua o número da rua nem o bairro.
                             */
                        } else {
                            var [route, city, state, _, postal_code] = addressComplete;

                            let cidadeSelect = this.removeAcentos(
                                `${state.short_name} - ${city.long_name}`
                            ).toLowerCase();

                            this.usuario.endereco = `${route.long_name}, ${postal_code.long_name}`;
                            this.usuario.bairro = '';
                            this.cidade = this.cidadesFull.find((elemento) => {
                                return elemento.nome.toLowerCase() == cidadeSelect;
                            });
                        }
                    } else {
                        this.usuario.endereco = '';
                        this.usuario.bairro = '';
                        this.cidade = null;
                        this.$refs.enderecoInput.focusedOut = false;
                        this.$refs.bairroInput.focusedOut = false;
                        this.$refs.cidadeSelect.focusedOut = false;
                    }
                } else {
                    this.msgs.push(
                        new Message('error', this.$t('msg-geocode-activate'), true, false)
                    );
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    input {
        text-transform: none;
    }

    .page {
        position: relative;
        padding-left: 0;
        display: block;
        clear: both;

        .replicapda-select {
            width: 50%;
        }

        .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 50%;
                padding-right: 10px;
            }
        }

        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0px !important;
            }

            .replicapda-select {
                width: 100%;
            }

            .descricao-tabela-parametrizacao {
                text-align: left;
                width: auto !important;
            }
        }

        @media screen and (max-width: 768px) {
            .b-table
                .table-wrapper.has-mobile-cards
                tr:not(.detail):not(.is-empty):not(.table-footer)
                td:before {
                word-break: initial;
            }
        }
    }
    .column {
        padding-top: 1px;
    }
    .without-background {
        background: none !important;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .box {
        background-color: #fdfdfd;
    }
    .column {
        height: 100% !important;
    }
    .get-location {
        height: 36px;
    }
    .hide-location {
        border: solid 2px #f9f9f9;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }
    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        // margin-top: 20px;
        position: relative;
        min-height: 350px;
        height: auto;
        margin-bottom: 20px;
        display: block;
        clear: both;
        border: solid 2px #f9f9f9;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }
    .nav.nav-tabs {
        margin-bottom: 5px;
        margin-top: 5px;
    }
}
</style>
